import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  contentTitlesHeader: {
    marginTop: 45
  },
  entitiesContainerWrapper: {
    padding: 24,
    border: '1px solid #c4c4c4',
    borderRadius: 12,
    margin: '20px 0px'
  },
  entitiesContainer: {
    maxHeight: 120,
    overflowY: 'auto'
  },
  entitiesTableHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 0.15fr',
    alignItems: 'center',
    color: 'grey',
    marginBottom: 4,
    position: 'sticky',
    top: 0,
    padding: '10px 0px',
    backgroundColor: '#f7f7f7'
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 0.15fr',
    alignItems: 'center',
    margin: '12px 0px'
  }
}))

export default useStyles
